import React from 'react'
import AddFiles from '../component/utilityAdmin/addFiles'

function AddFilesContainer() {
  return (
    <AddFiles/>
  )
}

export default AddFilesContainer